// removed by extract-text-webpack-plugin
module.exports = {"cookie-banner":"cookie-banner___gwDJs","cookie-banner__message":"cookie-banner__message___2MfTz","cookie-banner__button":"cookie-banner__button___2usBM"};